import { render, staticRenderFns } from "./TheMainLayout.vue?vue&type=template&id=68ad62a4"
import script from "./TheMainLayout.vue?vue&type=script&lang=js"
export * from "./TheMainLayout.vue?vue&type=script&lang=js"
import style0 from "./TheMainLayout.vue?vue&type=style&index=0&id=68ad62a4&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports